const defaultState = () => ({
  entityPermissions: undefined
})

export const state = defaultState()

export const getters = {
  ENTITY_PERMISSIONS (state) {
    return state.entityPermissions
  },
}

export const mutations = {
  RESET_STATE (state) {
    Object.assign(state, defaultState())
  },
  SET_ENTITY_PERMISSIONS (state, entityPermissions) {
    state.entityPermissions = entityPermissions
  },
  RESET_ENTITY_PERMISSIONS (state) {
    state.entityPermissions = undefined
  },
}
